import '@amplemarket/amplie/dist/esm/index.css';
import { createRoot } from 'react-dom/client';
import ZAFClient from 'zendesk_app_framework_sdk';
import Extension from 'extension/Extension';
import environment from 'shared/config/environment';
import * as toast from 'shared/toast';
import GlobalProvider from 'shared/wrappers/GlobalProvider';

document.addEventListener('DOMContentLoaded', async () => {
  const node = document.getElementById('react-zendesk-sell-lead-card-wrapper');

  if (node) {
    const data = JSON.parse(node.getAttribute('data'));

    // Compatibility shim to avoid changing much of the code inside the ProfilePage component
    const zafClient =
      environment.NODE_ENV === 'production'
        ? ZAFClient.init()
        : {
            get: () => {
              return Promise.resolve({
                lead: {
                  email: 'john.doe@amplemarket.com',
                  firstName: 'John',
                  lastName: 'Doe',
                },
              });
            },
            invoke: () => {},
          };

    const searchParams = new URLSearchParams(window.location.search);
    try {
      const response = await zafClient.get('lead');

      searchParams.set('email', response.lead.email);
      searchParams.set('name', `${response.lead.firstName} ${response.lead.lastName}`.trim());
    } catch (error) {
      if (error.message.includes('Could not find handler for: "lead"')) {
        try {
          const response = await zafClient.get('contact');
          searchParams.set('email', response.contact.email);
          searchParams.set(
            'name',
            `${response.contact.firstName} ${response.contact.lastName}`.trim()
          );
        } catch (e) {
          toast.errorMessage({
            title: 'Failed to load contact data',
            message: 'Retry. If the issue persists, contact support.',
          });
        }
      } else {
        toast.errorMessage({
          title: 'Failed to load lead data',
          message: 'Retry. If the issue persists, contact support.',
        });
      }
    }

    const newRelativePathQuery = `${window.location.pathname}?${searchParams.toString()}`;
    history.pushState(null, '', newRelativePathQuery);

    createRoot(node).render(
      <GlobalProvider>
        <Extension data={data} />
      </GlobalProvider>
    );
  }
});
